<template>
  <!-- @/assets/img/logos/signInBackImg.jpg -->

  <!-- Language Switcher -->
  <div class="language-switcher">
    <el-dropdown trigger="click" @command="changeLanguage" placement="bottom-end">
      <button class="language-btn">
        <i class="bi bi-globe"></i>
        <span class="language-text">{{ currentLanguageName }}</span>
        <i class="bi bi-chevron-down"></i>
      </button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="az" :class="{ 'is-active': currentLocale === 'az' }">
            <span class="flag-icon">🇦🇿</span>
            {{ $t('language.az') }}
          </el-dropdown-item>
          <el-dropdown-item command="en" :class="{ 'is-active': currentLocale === 'en' }">
            <span class="flag-icon">🇬🇧</span>
            {{ $t('language.en') }}
          </el-dropdown-item>
          <el-dropdown-item command="tr" :class="{ 'is-active': currentLocale === 'tr' }">
            <span class="flag-icon">🇹🇷</span>
            {{ $t('language.tr') }}
          </el-dropdown-item>
          <el-dropdown-item command="ru" :class="{ 'is-active': currentLocale === 'ru' }">
            <span class="flag-icon">🇷🇺</span>
            {{ $t('language.ru') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>

  <div class="container">
    <div class="row justify-content-center">
      <div class="mx-auto text-center col-lg-7">
        <h1 class="mt-5 mb-3 text-white">{{ $t('auth.welcome') }}</h1>
        <p class="text-white text-lead">
          {{ $t('auth.welcomeDescription') }}
        </p>
      </div>
    </div>
  </div>
  <div class="container" style="margin-top: 15%;">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0">
          <div class="text-center pt-4">
            <img class="at-logo" style="max-width: 220px; max-height: 180px;" :src="logo2">
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">{{ $t('auth.system') }}</label>
              <el-select v-model="sys" size="large" style="width: 100%" @change="handleChange">
                <el-option v-for="item in systems" :key="item.sys" :label="item.sys" :value="item.sys" />
              </el-select>
            </div>
            <div class="mb-3">
              <label class="form-label">{{ $t('auth.username') }}</label>
              <el-input v-model="this.log" placeholder="" size="large" style="width: 100%;"
                autocomplete="new-password" />
            </div>
            <div class="mb-3">
              <label class="form-label">{{ $t('auth.password') }}</label>
              <el-input @keyup.enter="signIn" v-model="this.password" type="password" placeholder="" size="large"
                style="width: 100%;" autocomplete="new-password" />
            </div>
            <div class="text-center">
              <input @click="signIn" type="submit" :value="$t('auth.login')" class="mb-0 btn btn-md bg-gradient-success w-100">
            </div>
            <div style="margin: 30px; margin-bottom: 0px; margin-top: 20px;" v-if="recaptchaReady">
              <vue-recaptcha :sitekey="this.recaptchaKey" size="normal" @verify="recaptchaVerified" ref="vueRecaptcha">
              </vue-recaptcha>
            </div>
            <div style="height: 10px;" v-show="message != null">
              <p style="margin-top: 5px;" class="text-danger text-center text-xs"><i
                  class="bi bi-exclamation-circle-fill"></i> {{ message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { setLocale } from '@/i18n';
import logo2 from "@/assets/img/logos/progressico2.png";
import Source from "../Source/dictionary.js";
// import { imgFile } from '../Source/helper.js';
import vueRecaptcha from 'vue3-recaptcha2';
import { recaptchaKey } from '@/project/Source/helper'

export default {
  name: "SigninIllustration",
  components: {
    vueRecaptcha
  },
  data() {
    return {
      log: null,
      logo2,
      systems: [],
      sys: null,
      password: "",
      url: null,
      message: null,
      recaptchaKey,
      isCaptchaValid: false,
      loading: false,
      recaptchaReady: false,
      recaptchaCheckAttempts: 0
    };
  },
  computed: {
    currentLocale() {
      const locale = this.$i18n.locale;
      return typeof locale === 'object' ? locale.value : locale;
    },
    currentLanguageName() {
      const localeMap = {
        'az': 'language.az',
        'en': 'language.en',
        'tr': 'language.tr',
        'ru': 'language.ru'
      };
      const key = localeMap[this.currentLocale] || 'language.az';
      return this.$t(key);
    }
  },
  methods: {
    changeLanguage(locale) {
      setLocale(locale);
    },
    recaptchaVerified() {
      this.isCaptchaValid = true;
    },
    handleChange(selectedSys) {
      const selectedItem = this.systems.find(item => item.sys === selectedSys);
      if (selectedItem) {
        this.url = selectedItem.url;
      }
    },
    signIn() {
      if (this.isCaptchaValid) {
        this.loading = true;

        this.message = null;
        event.preventDefault();
        const data = {
          requestCorrelationId: "string",
          username: this.log,
          password: this.password,
          system: this.sys
        };
        Source.Login(data).then((response) => {
          if (response.data.isSuccess) {
            if (this.sys === "CLAIMS" || this.sys === "MEDICAL" || this.sys === "ADMIN" || this.sys === "SUBRO") {
              window.location.href = `${this.url}/Session/${response.data.sessionId}`;
            } else {
              window.location.href = `${this.url}/Session.aspx?sessionId=${response.data.sessionId}`;
            }
          } else { 
            this.loading = false;
            this.message = response.data.errors[0];
            this.isCaptchaValid = false;
            if (this.$refs.vueRecaptcha) {
              this.$refs.vueRecaptcha.reset();
            }
            return;
          }
        });
      }
    },
    GetUserWindows() { 
      Source.UserName().then(() => { 
      })
    },
    initRecaptcha() {
      // Проверяем, загружен ли скрипт Google reCAPTCHA
      const checkRecaptcha = () => {
        if (window.grecaptcha && window.grecaptcha.render) {
          // Скрипт загружен, показываем капчу
          this.recaptchaReady = true;
          this.$nextTick(() => {
            if (this.$refs.vueRecaptcha) {
              // Принудительно перерисовываем капчу
              this.$refs.vueRecaptcha.reset();
            }
          });
        } else {
          // Скрипт еще не загружен, ждем еще (максимум 10 секунд)
          if (this.recaptchaCheckAttempts < 100) {
            this.recaptchaCheckAttempts = (this.recaptchaCheckAttempts || 0) + 1;
            setTimeout(checkRecaptcha, 100);
          } else {
            // Если скрипт не загрузился за 10 секунд, все равно показываем капчу
            this.recaptchaReady = true;
          }
        }
      };
      this.recaptchaCheckAttempts = 0;
      checkRecaptcha();
    }
  },
  mounted() {
    const data = {
      "requestCorrelationId": 'string'
    }

    Source.Systems(data).then((response) => {
      this.systems = response.data.data 
    })

    this.GetUserWindows()
    
    // Инициализируем капчу после монтирования компонента
    this.initRecaptcha();
  }
};
</script>
<style>
.container2 {
  display: flex;
  flex-direction: row;
}


.area {
  background: #4db2e5;
  background: -webkit-linear-gradient(to left, #4db2e5, #004eb3);
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  animation: animate 25s linear infinite;
  bottom: -150px;

}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}


.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}



@keyframes animate {

  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }

}

/* Language Switcher Styles */
.language-switcher {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.language-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.language-btn:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.language-btn i {
  font-size: 16px;
}

.language-text {
  min-width: 80px;
  text-align: left;
}

.el-dropdown-menu {
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.el-dropdown-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  transition: all 0.2s ease;
}

.el-dropdown-menu__item:hover {
  background: #f5f7fa;
}

.el-dropdown-menu__item.is-active {
  background: linear-gradient(135deg, #4db2e5 0%, #004eb3 100%);
  color: white;
  font-weight: 600;
}

.el-dropdown-menu__item.is-active .flag-icon {
  filter: brightness(1.2);
}

.flag-icon {
  font-size: 20px;
  line-height: 1;
}

@media (max-width: 768px) {
  .language-switcher {
    top: 15px;
    right: 15px;
  }
  
  .language-btn {
    padding: 8px 12px;
    font-size: 12px;
  }
  
  .language-text {
    min-width: 60px;
  }
}
</style>